/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Tile_SessionsInputs */

const en_us2_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`workouts this month`);
	return /** @type {LocalizedString} */ (`workouts this year`)
	
};

const pt_br2_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`treinos no mês`);
	return /** @type {LocalizedString} */ (`treinos no ano`)
	
};

const es_419_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`entrenamientos este mes`);
	return /** @type {LocalizedString} */ (`entrenamientos este año`)
	
};

const pt_pt2_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`treinos no mês`);
	return /** @type {LocalizedString} */ (`treinos no ano`)
	
};

const fr_fr2_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`séances ce mois-ci`);
	return /** @type {LocalizedString} */ (`séances cette année`)
	
};

const de_de2_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Trainings diesen Monat`);
	return /** @type {LocalizedString} */ (`Trainings dieses Jahr`)
	
};

const it_it2_wrapped_period_tile_sessions = /** @type {(inputs: Wrapped_Period_Tile_SessionsInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`allenamenti nel mese`);
	return /** @type {LocalizedString} */ (`allenamenti nell'anno`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "workouts this month" |
* | * | "workouts this year" |
*
* @param {Wrapped_Period_Tile_SessionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_tile_sessions = /** @type {((inputs: Wrapped_Period_Tile_SessionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Tile_SessionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_tile_sessions(inputs)
	if (locale === "es-419") return es_419_wrapped_period_tile_sessions(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_tile_sessions(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_tile_sessions(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_tile_sessions(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_tile_sessions(inputs)
	return en_us2_wrapped_period_tile_sessions(inputs)
});
export { wrapped_period_tile_sessions as "wrapped-period.tile_sessions" }